<div id="quality-audits" class="watermark">
  <div class="container-fluid px-lg-5">
    <div class="row">
      <div class="col-12 ">
        <h2 class="title">Quality Audits</h2>
      </div>
    </div>

    <div class="row justify-content-center mt-4">
      <div class="col-12 col-md-4 mb-4 text-center">
        <img src="/assets/img/iqac/audits/1.jpeg" alt="Energy Audit" class="img-fluid shadow-sm">
      </div>
      <div class="col-12 col-md-4 mb-4 text-center">
        <img src="/assets/img/iqac/audits/2.jpeg" alt="Accreditation Certificate" class="img-fluid shadow-sm">
      </div>
      <div class="col-12 col-md-4 mb-4 text-center">
        <img src="/assets/img/iqac/audits/3.jpeg" alt="Environment Audit" class="img-fluid shadow-sm">
      </div>
      <div class="col-12 col-md-4 mb-4 text-center">
        <img src="/assets/img/iqac/audits/4.jpeg" alt="Environment Audit" class="img-fluid shadow-sm">
      </div>
    </div>
  </div>
</div>